import React from 'react';
import { Product } from '../types/types';
import { ProductCard } from './ProductCard';
interface MenuSectionProps {
  title: string;
  products: Product[];
  onAddProduct: (product: Product) => void;
}
export function MenuSection({
  title,
  products,
  onAddProduct
}: MenuSectionProps) {
  if (products.length === 0) return null;
  // Check if products have subcategories (like Bebidas)
  const hasSubcategories = products.some(p => p.subcategory);
  if (hasSubcategories) {
    // Group by subcategory
    const groups: Record<string, Product[]> = {};
    products.forEach(p => {
      const sub = p.subcategory || 'Otros';
      if (!groups[sub]) groups[sub] = [];
      groups[sub].push(p);
    });
    return <div className="mb-8" data-id="element-264">
        <h2 className="text-xl font-heading font-bold text-white mb-4 px-1 tracking-wide" data-id="element-265">
          {title}
        </h2>
        {Object.entries(groups).map(([subcategory, subProducts]) => <div key={subcategory} className="mb-6" data-id="element-266">
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-3 px-1" data-id="element-267">
              {subcategory}
            </h3>
            <div className="grid grid-cols-2 gap-3" data-id="element-268">
              {subProducts.map(product => <ProductCard key={product.id} product={product} onAdd={onAddProduct} data-id="element-269" />)}
            </div>
          </div>)}
      </div>;
  }
  return <div className="mb-8" data-id="element-270">
      <h2 className="text-xl font-heading font-bold text-white mb-4 px-1 tracking-wide" data-id="element-271">
        {title}
      </h2>
      <div className="grid grid-cols-2 gap-3" data-id="element-272">
        {products.map(product => <ProductCard key={product.id} product={product} onAdd={onAddProduct} data-id="element-273" />)}
      </div>
    </div>;
}